import { FAMILIAS_DE_MATERIAL, chaveDoProprio } from "@bookdental/schemas";

export type MaterialDaBase = { id: string; nome: string; familia: string | null };
export type EscalaDaBase = { id: string; codigo: string; nome: string; padrao: boolean; cores: { id: string; cor: string }[] };
/** Serviço escolhido no passo 1 — da base (chave = id) ou criado pela pessoa (chave "proprio:<nome>"). */
export type ServicoEscolhido = { chave: string; nome: string; categoria: string; proprio?: boolean };
/** Material criado pela pessoa; `familia` (rótulo) quando ela o criou dentro de uma família. */
export type MaterialProprio = { nome: string; familia?: string };

const ORDEM_DA_FAMILIA = new Map<string, number>(FAMILIAS_DE_MATERIAL.map((f, i) => [f.codigo, i]));

export const ROTULO_DA_ABRANGENCIA: Record<"DENTE" | "ARCADA", string> = { DENTE: "Por dente", ARCADA: "Arcada completa" };

/** Nome de um material pela chave (id da base ou "proprio:<nome>"). */
export function nomeDoMaterial(chave: string, daBase: Map<string, MaterialDaBase>) {
  const proprio = chaveDoProprio("");
  return chave.startsWith(proprio) ? chave.slice(proprio.length) : (daBase.get(chave)?.nome ?? chave);
}

/** Materiais da base na ordem do cadastro: por família, depois a ordem da base. */
export const porFamilia = (materiais: MaterialDaBase[]) =>
  [...materiais].sort((a, b) => (ORDEM_DA_FAMILIA.get(a.familia ?? "") ?? 99) - (ORDEM_DA_FAMILIA.get(b.familia ?? "") ?? 99));

/** "Zircônia, Dissilicato de lítio +3" — o resumo de uma linha. */
export function resumoDosMateriais(nomes: string[], max = 2) {
  if (nomes.length === 0) return "Sem material";
  return nomes.length <= max ? nomes.join(", ") : `${nomes.slice(0, max).join(", ")} +${nomes.length - max}`;
}
